<template>
  <div>
    <el-container>
      This page is a stub for a feature not yet implemented
    </el-container>
  </div>
</template>

<script type="text/babel">
export default {
  name: "TodoPage",
  components: {},
  data() {
    return {};
  }
};
</script>
